import { extendTheme } from '@chakra-ui/react';
import { theme } from '@codametrix/ui-common';
import { Messages } from './views/patient-timeline/patient-timeline-styles';
import { CMXIconStyles } from './views/cmx-icon/cmx-icon-styles';
import { Drawer } from './views/cmx-drawer/cmx-drawer-styles';
export default extendTheme(theme, {
    useSystemColorMode: false,
    components: {
        Messages,
        CMXIconStyles,
        Drawer,
        CloseButton: {
            baseStyle: {
                borderRadius: "md",
                transitionProperty: "common",
                transitionDuration: "normal",
                _hover: {
                    bg: "blackAlpha.100"
                },
                _active: {
                    bg: "blackAlpha.200"
                },
                _focus: {
                    boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)"
                },
                "& svg": {
                    width: "1.15em",
                    height: "1.15em"
                }
            },
            sizes: {
                sm: {
                    w: "24px",
                    h: "24px"
                },
                md: {
                    w: "32px",
                    h: "32px"
                },
                lg: {
                    w: "48px",
                    h: "48px"
                }
            },
            defaultProps: {
                size: "md"
            }
        },
        NumberInput: {
            baseStyle: {
                field: {
                    fontSize: "16px"
                }
            },
            variants: {
                outline: {
                    field: {
                        _focus: {
                            borderColor: "blue.500",
                            boxShadow: "0 0 0 1px #3182ce"
                        }
                    }
                }
            },
            defaultProps: {
                allowMouseWheel: false,
                clampValueOnBlur: true
            }
        }
    }
});
